import React, { useState, useEffect } from "react";
import { getData, getOneData, postData } from "../components/helpers/Data";
import { Spinner } from "../components/helpers/Spinner";
import ReactHTMLTableToExcel from "react-html-table-to-excel";
import htmlToPdfmake from "html-to-pdfmake";
import pdfMake from "pdfmake/build/pdfmake";

const ProfitLossReport = () => {
  const [reportData, setReportData] = useState([]);
  const [loses, setLoses] = useState([]);
  const [totals, setTotals] = useState([]);

  var index = 0;

  const fetchReport = (e) => {
    e.preventDefault();
    setReportData([]);
    setLoses([]);
    setTotals([]);
    const frmData = new FormData(document.getElementById("loss_profit_frm"));

    document.getElementById("spinner").style.display = "block";
    postData(frmData, "profit_loss_report")
      .then((data) => {
        setReportData(data.data);
        setLoses(data.loses);
        setTotals(data.totals);
        document.getElementById("spinner").style.display = "none";
      })
      .catch((error) => console.log(error));
  };

  const printPdf = (e) => {
    e.preventDefault();

    const tbl = document.getElementById("tableDiv").innerHTML;

    let title = "PROFIT LOSS REPORT";

    let j = `
  <div class="row">
  <br><br><br>
  <div class="row">
  <div class="col-md-4" style="font-size:25px;font-weight:bold;text-align:center;">${title}</div>
  <br>
  </div>
  <div>${tbl}</div>  
  </div>
  `;

    var val = htmlToPdfmake(j);
    var dd = {
      pageOrientation: "landscape",
      pageMargins: [40, 60, 40, 60],
      content: val,
      pageSize: "A4",
    };
    pdfMake.createPdf(dd).download();
  };
  return (
    <div className="row">
      <h5>PROFIT / LOSS REPORT</h5>
      <div className="card col-md-3 bg-light p-2 mt-2" style={{ height: "250px" }}>
        <form id="loss_profit_frm" onSubmit={fetchReport}>
          <label htmlFor="from" className="col-form-label col-md-2">
            From:
          </label>
          <input
            className="form-control col-md-2"
            type="date"
            name="from"
            id="from"
          />
          <label htmlFor="to" className="col-form-label col-md-2">
            To:
          </label>
          <input
            className="form-control col-md-2 mb-5"
            type="date"
            name="to"
            id="to"
          />
          <button type="submit" className="btn btn-info btn-sm">
            Run
          </button>
        </form>
      </div>
      <section className="project-tab col-md-8 ml-2">
        <div className="row">
          <div className="col-md-12">
            {/* <div className="row"> */}
            {/* <button
              type="button"
              className="btn btn-sm btn-success col-md-12"
              onClick={printPdf}
            >
              Print
            </button> */}
            {/* </div> */}
            <div className="row" id="tableDiv">
              <div className="card p-2">
                <span className="text text-success text-center">
                  SALES
                </span>
                <hr />
                <ReactHTMLTableToExcel
                  className="btn btn-sm btn-info"
                  id="tbl_1"
                  table="tbl1"
                  filename="sales_report"
                  sheet="sales report"
                  buttonText="Export"
                />
                <table
                  className="table table-bordered table-sm table-stripped"
                  id="tbl1"
                  style={{ maxHeight: "200px" }}
                >
                  <thead>
                    <tr>
                      <th>Index</th>
                      <th>Items</th>
                      <th>Sales Date</th>
                      <th>Quantity Sold</th>
                      <th>Wholesale Price</th>
                      <th>Retail Price</th>
                      <th>Total Wholesale Price</th>
                      <th>Total Retail Price</th>
                      <th>Profit</th>
                    </tr>
                  </thead>
                  <tbody>
                    {reportData.map((dt) => {
                      index++;
                      return (
                        <tr key={dt.id}>
                          <td>{index}</td>
                          <td>{dt.manufacturer_item}</td>
                          <td>{dt.sales_date}</td>
                          <td>{dt.quantity_in_nos}</td>
                          <td>
                            {dt.wholesale_price_per_drug
                              ? parseFloat(
                                  dt.wholesale_price_per_drug
                                ).toLocaleString()
                              : 0}
                          </td>
                          <td>
                            {dt.retail_price_per_drug
                              ? parseFloat(
                                  dt.retail_price_per_drug
                                ).toLocaleString()
                              : 0}
                          </td>
                          <td>
                            {dt.purchase_price
                              ? parseFloat(dt.purchase_price).toLocaleString()
                              : 0}
                          </td>
                          <td>
                            {dt.sale_price
                              ? parseFloat(dt.sale_price).toLocaleString()
                              : 0}
                          </td>
                          <td>
                            {dt.sale_difference
                              ? parseFloat(dt.sale_difference).toLocaleString()
                              : 0}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                  <tfoot>
                    <tr>
                      <th></th>
                      <th></th>
                      <th></th>
                      <th></th>
                      <th></th>
                      <th>Totals</th>
                      <th>
                        {totals.ttl_purchase
                          ? parseFloat(totals.ttl_purchase).toLocaleString()
                          : 0}
                      </th>
                      <th>
                        {totals.ttl_sales
                          ? parseFloat(totals.ttl_sales).toLocaleString()
                          : 0}
                      </th>
                      <th>
                        {totals.total_sale_difference
                          ? parseFloat(
                              totals.total_sale_difference
                            ).toLocaleString()
                          : 0}
                      </th>
                    </tr>
                  </tfoot>
                </table>
              </div>
              <div className="card p-2">
                <span className="text text-success text-center">
                 LOSS
                </span>
                <ReactHTMLTableToExcel
                  className="btn btn-sm btn-info"
                  table="tbl2"
                  filename="loss_report"
                  sheet="loss report"
                  buttonText="Export"
                />
                <table
                  className="table table-bordered table-sm table-stripped"
                  id="tbl2"
                  style={{ maxHeight: "200px" }}
                >
                  <thead>
                    <tr>
                      <th>Items</th>
                      <th>Quantity Expired or Spoilt</th>
                      <th>Wholesale Price</th>
                      <th>Total Loss</th>
                    </tr>
                  </thead>
                  <tbody>
                    {loses.map((dt) => {
                      index++;
                      return (
                        <tr>
                          <td>{dt.manufacturer_item}</td>
                          <td>
                            {dt.quantity_expired_or_spoilt
                              ? parseFloat(
                                  dt.quantity_expired_or_spoilt
                                ).toLocaleString()
                              : 0}
                          </td>
                          <td>
                            {dt.wholesale_price_per_drug
                              ? parseFloat(
                                  dt.wholesale_price_per_drug
                                ).toLocaleString()
                              : 0}
                          </td>
                          <td>
                            {dt.total_loss
                              ? parseFloat(dt.total_loss).toLocaleString()
                              : 0}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                  <tfoot>
                    <tr>
                      <th></th>
                      <th></th>
                      <th></th>
                      <th>
                        {totals.spoilt_expired
                          ? parseFloat(totals.spoilt_expired).toLocaleString()
                          : 0}
                      </th>
                    </tr>
                  </tfoot>
                </table>
              </div>
              <div className="card p-2">
                <span className="text text-success text-center">
                  PROFIT
                </span>
                <ReactHTMLTableToExcel
                  className="btn btn-sm btn-info"
                  table="tbl3"
                  filename="profit_report"
                  sheet="profit report"
                  buttonText="Export"
                />
                <table className="table-hover table-bordered" id="tbl3">
                  <tbody>
                    <tr>
                      <th>Total Profit from sales</th>
                      <th>
                        {totals.total_sale_difference
                          ? parseFloat(
                              totals.total_sale_difference
                            ).toLocaleString()
                          : 0}
                      </th>
                    </tr>
                    <tr>
                      <th>Total loses</th>
                      <th>
                        {" "}
                        {totals.spoilt_expired
                          ? parseFloat(totals.spoilt_expired).toLocaleString()
                          : 0}
                      </th>
                    </tr>
                    <tr>
                      <th>Total Profit</th>
                      <th>
                        {totals.profit_loss
                          ? parseFloat(totals.profit_loss).toLocaleString()
                          : 0}
                      </th>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <Spinner />
          </div>
        </div>
      </section>
    </div>
  );
};

export default ProfitLossReport;
